module.exports = __webpack_public_path__ + "static/img/4.bb5d6da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/sp/4.png
// module id = FRHx
// module chunks = 0